import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import webservice from '../common/Webservice';
import {AjaxSpinner, ColumnInformation, SegmentedButton, SelectInput, Size, Table, TableSorter, TableSorterField, TableSorterInformation} from "@utahdts/dts-react-common";
import {COLOR_PALETTE, contentLength, footerNotice, formatAmount, MAX_CHARACTERS, MEDIA_SIZES} from "../misc/Shared";
import {ResponsiveBarCanvas} from "@nivo/bar";
import {format} from "d3-format";
import Media from "react-media";
import {Link} from 'react-router-dom';
import clone from 'clone';
import {cookies, createCookie, verifyCookie} from "../misc/Cookies";
import {isEmpty} from "lodash";

const propTypes = {
	currentCobiId:  PropTypes.number,

	currentTab:  PropTypes.string,

	currentYear:  PropTypes.number,

	draft: PropTypes.bool,
};

const defaultProps = {
};

// Props connected to the store
const mapStateToProps = state => ({
	currentCobiId: state.app.currentCobiId,
	currentTab: state.app.currentTab,
	currentYear: state.app.currentYear,
	draft: state.app.draft
});

const yearsOrder = [
	"fourYearsAgo",
	"threeYearsAgo",
	"twoYearsAgo",
	"oneYearAgo",
	"currentYearEst",
	"currentYear",
	"billYear"
];

const TABLE_TYPE = {
	BUDGET: 'budgetTable',
	OTHER: 'otherTable',
};

class Financials extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			content: undefined,
			currentAppType: undefined,
			currentDisplayBy: undefined,
			currentDisplayByOptions: [],
			tableData: undefined,
			graphData: undefined,
			graphKeys: undefined,
			tableType: 'budgetTable',
			mobileYearsOptions: [],
			mobileYears: [],
			busy: false,
			readMore: false,
			printing: false
		};

		this.setContent = this.setContent.bind(this);
		this.getContent = this.getContent.bind(this);
		this.populateFirstTableHeader = this.populateFirstTableHeader.bind(this);

		this.getContent();

		const sortTitle = new TableSorterField('title', TableSorter.SORT.TEXT, TableSorter.DIRECTION.ASCENDING);
		const sortFourYearsAgo = new TableSorterField('fourYearsAgo', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const sortThreeYearsAgo = new TableSorterField('threeYearsAgo', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const sortTwoYearsAgo = new TableSorterField('twoYearsAgo', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const sortOneYearAgo = new TableSorterField('oneYearAgo', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const sortCurrentYearEst = new TableSorterField('currentYearEst', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const sortCurrentYear = new TableSorterField('currentYear', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const sortBillYear = new TableSorterField('billYear', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const sortSequence = new TableSorterField('sequence', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);

		this.columns = [
			new ColumnInformation({
				title: 'Sources of Finance',
				field: 'title',
				tableSorterInformation: new TableSorterInformation([sortTitle, sortBillYear]),
				tdCallback: (columnInfo, objectData) => (<td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{this.renderTitle(objectData)}</td>)
			}),
			new ColumnInformation({
				title: 'Placeholder',
				field: 'fourYearsAgo',
				tableSorterInformation: new TableSorterInformation([sortFourYearsAgo, sortBillYear]),
				tdCallback: (columnInfo, objectData) => (<td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{formatAmount(objectData.fourYearsAgo, 0, undefined, undefined, true)}</td>)
			}),
			new ColumnInformation({
				title: 'Placeholder',
				field: 'threeYearsAgo',
				tableSorterInformation: new TableSorterInformation([sortThreeYearsAgo, sortBillYear]),
				tdCallback: (columnInfo, objectData) => (<td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{formatAmount(objectData.threeYearsAgo, 0, undefined, undefined, true)}</td>)
			}),
			new ColumnInformation({
				title: 'Placeholder',
				field: 'twoYearsAgo',
				tableSorterInformation: new TableSorterInformation([sortTwoYearsAgo, sortBillYear]),
				tdCallback: (columnInfo, objectData) => (<td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{formatAmount(objectData.twoYearsAgo, 0, undefined, undefined, true)}</td>)
			}),
			new ColumnInformation({
				title: 'Placeholder',
				field: 'oneYearAgo',
				tableSorterInformation: new TableSorterInformation([sortOneYearAgo, sortBillYear]),
				tdCallback: (columnInfo, objectData) => (<td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{formatAmount(objectData.oneYearAgo, 0, undefined, undefined, true)}</td>)
			}),
			new ColumnInformation({
				title: 'Placeholder',
				field: 'currentYearEst',
				tableSorterInformation: new TableSorterInformation([sortCurrentYearEst, sortBillYear]),
				tdCallback: (columnInfo, objectData) => (<td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{formatAmount(objectData.currentYearEst, 0, undefined, undefined, true)}</td>)
			}),
			new ColumnInformation({
				title: 'Placeholder',
				field: 'currentYear',
				tableSorterInformation: new TableSorterInformation([sortCurrentYear, sortBillYear]),
				tdCallback: (columnInfo, objectData) => (<td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{formatAmount(objectData.currentYear, 0, undefined, undefined, true)}</td>)
			}),
			new ColumnInformation({
				title: 'Placeholder',
				field: 'billYear',
				tableSorterInformation: new TableSorterInformation([sortBillYear]),
				tdCallback: (columnInfo, objectData) => (<td key={columnInfo.field ? columnInfo.field : columnInfo.key}>{formatAmount(objectData.billYear, 0, undefined, undefined, true)}</td>)
			}),
			new ColumnInformation({
				title: 'Sequence',
				field: 'sequence',
				tableSorterInformation: new TableSorterInformation([sortSequence, sortTitle]),
				tdClassName: 'hidden',
				thClassName: 'hidden'
			})
		];
	}

	componentDidMount() {
		window.onbeforeprint = () => this.setState({printing: true});
		window.onafterprint = () => this.setState({printing: false});
	}

	componentDidUpdate(prevProps, prevState) {
		if ((prevState.currentDisplayBy !== this.state.currentDisplayBy) || (prevState.currentAppType !== this.state.currentAppType) || (prevProps.currentCobiId !== this.props.currentCobiId) || (this.props.currentYear !== prevProps.currentYear)) {
			const updateMobileYears = prevProps.currentCobiId !== this.props.currentCobiId;
			this.chartType = this.state.currentDisplayBy.includes('category') ? 'categoryChart' : 'hierarchyChart';
			this.category = this.currentDisplayByOptions.find(option => (option.value === this.state.currentDisplayBy)).type;
			!this.isCancelled && this.setState({busy: true}, () => webservice.public.tab.chart(this.props.currentCobiId, this.props.currentYear, this.category, this.state.currentAppType, this.chartType).then(data => !this.isCancelled && this.setState({
				tableData: data,
				busy: false
			}, () => {
				this.generateGraphData(updateMobileYears);
				this.populateTableHeader();
				this.populateFirstTableHeader(this.state.tableType);
			})));
		}

		if (prevProps.currentCobiId !== this.props.currentCobiId) {
			this.getContent();
		}
	}

	componentWillUnmount() {
		this.isCancelled = true;
	}

	getContent() {
		this.props.draft ?
			webservice.admin.tab.draft(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(this.setContent)
			: webservice.public.tab.content(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(this.setContent);
	}

	setContent(data) {
		const displayOptions = this.generateDisplayOptions(data.displayBy);
		this.currentDisplayByOptions = displayOptions;
		// sort appropriationsType dropdown by sequence
		data.appropriationsType.sort((a,b) => a.sequence.localeCompare(b.sequence));
		const currentAppType = verifyCookie(cookies.currentAppType, data.appropriationsType);
		const currentDisplayBy = verifyCookie(cookies.currentDisplayBy, displayOptions);
		!this.isCancelled && this.setState({
			content: data,
			currentAppType: currentAppType[0],
			currentDisplayBy: currentDisplayBy[0]
		});
	}

	renderTitle(objectData) {
		let title = objectData.title;
		if (objectData.useLink) {
			title = <a href={'https://le.utah.gov' + objectData.useLink} target="_blank">{title}</a>;
		} else if (objectData.cobiId) {
			title = <Link to={`/${this.props.currentYear}/${objectData.cobiId}/financials${this.props.draft ? '/draft' : ''}`}>{title}</Link>;
		} else if (objectData.fund) {
			title = <Link to={`/fund/${objectData.fund}`}>{title}</Link>;
		}
		return title;
	}

	generateDisplayOptions(data) {
		return data.map(option => ({label: option.label, value: `${option.value}-${option.type}`, type: option.type}));
	}

	populateTableHeader() {
		for(let i = 1; i < this.columns.length; i++) {
			this.columns[i].title = this.state.tableData.header[i-1];
		}
		this.columns[this.columns.length - 1].title = 'Sequence';
	}

	populateFirstTableHeader(tableType) {
		const currentDisplayBy = this.currentDisplayByOptions.find(o => o.value === this.state.currentDisplayBy);
		if(tableType === TABLE_TYPE.OTHER) {
			this.columns[0].title = 'Other Indicators';
		} else if(currentDisplayBy.type === 'expenditure') {
			this.columns[0].title = 'Categories of Expenditure';
		} else if(!currentDisplayBy.value.includes('category')){
			this.columns[0].title = currentDisplayBy.label;
		} else {
			this.columns[0].title = 'Sources of Finance';
		}
	}

	generateGraphData(updateMobileYears) {
		let items = [];
		let keys = [];
		let options = [];
		let mobileYears = this.state.mobileYears;
		for(let i = 0; i < this.state.tableData.header.length; i++) {
			let item = {};
			options.push({ label: this.state.tableData.header[i], value: this.state.tableData.header[i]});
			item.year = this.state.tableData.header[i];
			for(let j = 0; j < this.state.tableData["budgetTable"].length; j++) {
				item[this.state.tableData["budgetTable"][j].title] = this.state.tableData["budgetTable"][j][yearsOrder[i]];
				keys.length < this.state.tableData["budgetTable"].length ? keys.push(this.state.tableData["budgetTable"][j].title) : undefined;
			}
			items.push(item);
		}
		mobileYears = updateMobileYears || this.state.mobileYears.length === 0 ? options.length > 1 ? [options[options.length - 1].value, options[options.length - 2].value] : mobileYears : mobileYears;
		this.setState({ graphData: items, graphKeys: keys, mobileYearsOptions: options, mobileYears: mobileYears });
	}

	getDisplayByName() {
		const currentOption = this.currentDisplayByOptions.find(option => {return option.value === this.state.currentDisplayBy});
		return currentOption.label;
	}

	getTotals(data) {
		if (this.state.tableType === TABLE_TYPE.BUDGET) {
			data = clone(data);
			const totals = data.length > 0 ? data.reduce((a, v) => ({
				fourYearsAgo: a.fourYearsAgo + v.fourYearsAgo,
				threeYearsAgo: a.threeYearsAgo + v.threeYearsAgo,
				twoYearsAgo: a.twoYearsAgo + v.twoYearsAgo,
				oneYearAgo: a.oneYearAgo + v.oneYearAgo,
				currentYearEst: a.currentYearEst + v.currentYearEst,
				currentYear: a.currentYear + v.currentYear,
				billYear: a.billYear + v.billYear
			})) : {
				fourYearsAgo: 0,
				threeYearsAgo: 0,
				twoYearsAgo: 0,
				oneYearAgo: 0,
				currentYearEst: 0,
				currentYear: 0,
				billYear: 0
			};
			totals.title = 'Total';
			totals.cobiId = null;
			return totals;
		}
	}

    getMobileFormat(data) {
        data = clone(data);
        const segmentArray = [];

        const fields = this.columns.filter(col => {
            return [].concat(this.state.mobileYears).includes(col.title);
        });

        data.map((d, index) => {
            let segment = new Object();

            segment.title = d.title;
            segment.renderedTitle = this.renderTitle(d);
            segment.data = [];
            fields.map(col => {
                let info = new Object();
                info.type = col.title;
                info.field = d[col.field];
                segment.data.push(info);
            });

            segmentArray.push(segment);
        });
        if (this.state.tableType === TABLE_TYPE.BUDGET) {
            let totals = segmentArray.reduce((a, v) => {
                v.data.forEach(item => {
                    let index = a.data.findIndex(function (e) {
                        return e.type === item.type;
                    });

                    if (index > -1) {
                        a.data[index].field += item.field;
                    } else {
                        a.data.push(clone(item));
                    }
                });

                return a;
            }, {
                title: "Totals",
                renderedTitle: "Totals",
                data: []
            });

            segmentArray.push(totals);
        }
        return segmentArray;
    }

    isTableData(data) {
		let retval = false;
		for(let key in data) {
			if(!isEmpty(data[key]))
				retval = true;
		}
		return retval;
	}

	render() {
		return (
			<React.Fragment>
				{ this.state.content &&
				<section className={"fr-view"}>
					<Media query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}>
						{matches =>
							matches ? (
									<React.Fragment>
										<div className={contentLength(this.state.content.text.tabHtml, MAX_CHARACTERS) && (this.state.readMore ? "" : "read-more")} dangerouslySetInnerHTML={{__html: this.state.content.text.tabHtml}}/>
										{contentLength(this.state.content.text.tabHtml, MAX_CHARACTERS) && (!this.state.readMore && <a onClick={() => this.setState({ readMore: true })} className="mb-spacing bold-text inline-block atid_read-more-link">READ MORE <span className="ml-spacing-small">&raquo;</span></a>)}
									</React.Fragment>
								) : (
									<div dangerouslySetInnerHTML={{__html: this.state.content.text.tabHtml}} />
								)
						}
					</Media>
					{ this.state.tableData && this.isTableData(this.state.tableData) &&<div>
						<Media
							query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}
							render={() => <h4>Filters</h4>}
						/>
						<div className="flex flex-wrap align-end">
							<SelectInput
								field="currentAppType"
								label="Appropriations Type:"
								allowClear={false}
								showSearch={false}
								className="mr-spacing stack-form full-mobile normal-font"
								options={this.state.content.appropriationsType}
								value={this.state.currentAppType}
								onChange={(field, val) => this.setState({ currentAppType: val }, () => createCookie(field, val, 365))}
								size={window.outerWidth < 767 ? Size.FULL_WIDTH : Size.XLARGE}
							/>
							<SegmentedButton
								label="Display by:"
								field="currentDisplayBy"
								className="mr-spacing flex-mobile"
								value={this.state.currentDisplayBy}
								options={this.currentDisplayByOptions}
								onChange={(field, val) => this.setState({ currentDisplayBy: val }, () => createCookie(field, val, 365))}
							/>
							{this.state.busy && <AjaxSpinner size={30} className="mb-spacing"/>}
						</div>
						<div>
							<Media
								query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}
								render={() => (<SelectInput
									field="mobileYears"
									label="Year to show:"
									allowClear={false}
									showSearch={false}
									className="mr-spacing stack-form full-mobile normal-font"
									options={this.state.mobileYearsOptions}
									value={this.state.mobileYears}
									onChange={(field, val) => this.setState({mobileYears: val})}
									multiSelect={true}
								/>)}
							/>
							<h3 className="center-text">Appropriation History by {this.getDisplayByName()}</h3>
							<div className="bar-graph" style={this.state.printing ? {width: '8.5in'} : undefined}>
								<ResponsiveBarCanvas
									data={this.state.graphData && window.outerWidth < 767 ? this.state.graphData.filter(item => this.state.mobileYears.includes(item.year)) : this.state.graphData}
									indexBy="year"
									margin={{
										"top": 50,
										"right": 20,
										"bottom": window.outerWidth < 767 ? 150 : 50,
										"left": 60
									}}
									keys={this.state.graphKeys}
									padding={0.3}
									borderColor="inherit:darker(1.6)"
									axisBottom={{
										"orient": "bottom",
										"tickSize": 5,
										"tickPadding": 5,
										"tickRotation": window.outerWidth < 767 ? 90 : 0,
									}}
									axisLeft={{
										"orient": "left",
										"tickSize": 5,
										"tickPadding": 5,
										"tickRotation": 0,
										"format": v => format(".2s")(v).replace(/G/,"B")
									}}
									labelSkipWidth={12}
									labelSkipHeight={12}
									labelTextColor="inherit:darker(1.6)"
									animate={true}
									motionStiffness={90}
									motionDamping={15}
									enableLabel={false}
									colors={COLOR_PALETTE}
									tooltip={(data) => {
										return <div className="barToolTip">{data.id}: <strong>${formatAmount(data.value, 0, undefined, undefined, true)}</strong></div>;
									}}
								/>
							</div>
							<SegmentedButton
								label="Show:"
								field="tableType"
								value={this.state.tableType}
								className="flex-mobile"
								options={[
									{label: 'Budget Information', value: TABLE_TYPE.BUDGET},
									{label: 'FTEs, Vehicles, WPUs, etc.', value: TABLE_TYPE.OTHER}
								]}
								onChange={(field, val) => {
									this.populateFirstTableHeader(val);
									this.setState({ tableType: val });
								}}
							/>
							{isEmpty(this.state.tableData[this.state.tableType]) ?
								<div>There is no table information to display</div>
							: <Media query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}>
								{matches =>
									matches ? (
											<div>
                                                {this.getMobileFormat(this.state.tableData[this.state.tableType]).map((segment, index) =>
                                                    (<div key={segment.title} className={`row atid_table-row-mobile${index}`}>
                                                        <div className="sub-row">
                                                            <div className="title bold-text">{segment.renderedTitle}</div>
                                                            {segment.data.map(row => {
                                                                return (<div key={row.type} className="flex sub-row">
                                                                        <div className="title">{row.type}:</div>
                                                                        <div className="data">{formatAmount(row.field, 0, undefined, undefined, true)}</div>
                                                                </div>);
                                                            })}
                                                        </div>
                                                    </div>
                                                ))}
											</div>
										) : (
											<Table
												columns={this.columns}
												list={this.state.tableData[this.state.tableType]}
												totals={this.getTotals(this.state.tableData[this.state.tableType])}
												defaultSortField={'sequence'}
											/>
										)
								}
							</Media>
							}
						</div>
					</div>}
					{footerNotice('mt-spacing-large')}
				</section> }
			</React.Fragment>
		);
	}
}

Financials.propTypes = propTypes;
Financials.defaultProps = defaultProps;

export default connect(mapStateToProps)(Financials);
